import React from 'react';

import { Container, SearchContainer, SearchInput, SearchIcon, ClearIcon } from './styles';

export default function SearchBar({ value, onChange, placeholder }) {
  return (
    <Container>
      <SearchContainer>
        <SearchInput
          value={value}
          placeholder={placeholder || 'Search...'}
          onChange={(e) => onChange(e.target.value)}
        />
        {value ? <ClearIcon onClick={() => onChange('')} /> : <SearchIcon />}
      </SearchContainer>
    </Container>
  );
}
